module.exports = __webpack_public_path__ + "static/media/4ODA19.a0356eab.jpg";